document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('descriptionContainer');
  const toggleBtn = document.getElementById('toggleButton');
  const collapsedHeight = 50;

  if (!container || !toggleBtn) {
    // Exit early if elements are not present
    return;
  }

  function checkOverflow() {
    if (container.scrollHeight > collapsedHeight) {
      toggleBtn.style.display = 'inline-block';
    } else {
      toggleBtn.style.display = 'none';
    }
  }

  toggleBtn.addEventListener('click', function () {
    const isExpanded = container.classList.toggle('expanded');
    toggleBtn.textContent = isExpanded ? 'Read less' : 'Read more';
  });

  // Run on page load
  checkOverflow();
});


// Megamenu hover delay override (non-invasive)
(function() {
  const HOVER_DELAY_MS = 500;
  const timeoutsByTrigger = new WeakMap();
  let lastScheduledTrigger = null;
  let allowImmediateOnce = false;

  function isMeganavTrigger(el) {
    return !!el && el.hasAttribute && el.hasAttribute('data-meganav-trigger');
  }

  function closestTrigger(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-meganav-trigger]');
  }

  function clearTriggerTimeout(trigger) {
    const id = timeoutsByTrigger.get(trigger);
    if (id) {
      clearTimeout(id);
      timeoutsByTrigger.delete(trigger);
    }
  }

  function cancelAll() {
    // WeakMap cannot be iterated reliably; rely on per-event clears via mouseleave/non-trigger hover
  }

  function onMouseOverCapture(e) {
    // Allow a single immediate open for our synthetic event
    if (allowImmediateOnce) {
      allowImmediateOnce = false;
      return;
    }
    const trigger = closestTrigger(e.target);
    if (!trigger) {
      // Hovering a non-trigger: cancel any pending timeout on the last hovered trigger (if any exists on the event path)
      if (lastScheduledTrigger) {
        clearTriggerTimeout(lastScheduledTrigger);
        lastScheduledTrigger = null;
      }
      return;
    }

    // Stop the theme's immediate mouseover handler from opening instantly
    e.stopPropagation();

    // If already scheduled, ignore; else set a delay to open
    if (timeoutsByTrigger.get(trigger)) return;

    // Cancel previous scheduled trigger if different
    if (lastScheduledTrigger && lastScheduledTrigger !== trigger) {
      clearTriggerTimeout(lastScheduledTrigger);
    }
    lastScheduledTrigger = trigger;

    const handle = trigger.getAttribute('data-meganav-handle');
    const id = setTimeout(() => {
      try {
        // Set a flag to allow one immediate open, then dispatch a synthetic mouseover to use theme's original handler
        allowImmediateOnce = true;
        trigger.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
      } catch (err) {
        // no-op
      } finally {
        clearTriggerTimeout(trigger);
      }
    }, HOVER_DELAY_MS);
    timeoutsByTrigger.set(trigger, id);
  }

  function onMouseLeaveCapture(e) {
    const trigger = closestTrigger(e.target);
    if (!trigger) return;
    clearTriggerTimeout(trigger);
  }

  // Capture phase ensures we intercept before theme's bubbling handlers
  document.addEventListener('mouseover', onMouseOverCapture, true);
  document.addEventListener('mouseleave', onMouseLeaveCapture, true);
  // No DOM open logic here; we always defer to theme's own handlers via synthetic events
})();

// bmanuka speed: muted videos marked data-bm-lazy-video start when they get near the screen and pause when they leave it.
(function () {
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function start() {
    var videos = document.querySelectorAll('video[data-bm-lazy-video]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) { videos.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '300px 0px' });
    videos.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* bmanuka 4.11: height of everything above the header (announcement + sale timer), see custom-dev.css */
(function () {
  var bars = document.querySelectorAll('.announcement-bar, .countdown-banner--bar');
  if (!bars.length) return;
  var root = document.documentElement;
  function setHeight() {
    var h = 0;
    for (var i = 0; i < bars.length; i++) h += bars[i].offsetHeight;
    root.style.setProperty('--bm-top-bars', h + 'px');
  }
  setHeight();
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(setHeight);
    for (var i = 0; i < bars.length; i++) ro.observe(bars[i]);
  }
})();

